"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const app_platform_internal_api_sdk_1 = require("@semios/app-platform-internal-api-sdk");
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    propertyIds: zod_1.z.array(zod_1.z.number()),
    entityIdentifiers: zod_1.z.array(zod_1.z.string()).optional(),
    issueStatuses: zod_1.z.array(zod_1.z.nativeEnum(app_platform_internal_api_sdk_1.TServiceIssueStatus)).optional(),
});
exports.path = '/service-center-node-service-issues-get';
//# sourceMappingURL=index.js.map